module.exports = "/assets/d27ad8510dcf0eef13f6419f4f9a76e6.svg";